
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5307_8304)"}},[_c('path',{attrs:{"d":"M0 0l13.125 7.8-4.375 3.6L0 7.2V0zm0 8.4l4.083 2.7L0 24 14 8.4v7.2L0 24V8.4z","fill":"currentColor"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"jnfwkfy29a","maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"13","height":"13"}},[_c('path',{attrs:{"fill":"currentColor","d":"M12 12h13v13H12z"}})]),_c('g',{attrs:{"mask":"url(#jnfwkfy29a)"}},[_c('path',{attrs:{"d":"M22.613 23.37l-3.034-3.033a3.301 3.301 0 01-2.058.704c-.984 0-1.817-.34-2.498-1.021-.682-.682-1.023-1.515-1.023-2.5 0-.983.34-1.816 1.023-2.498.681-.681 1.514-1.022 2.498-1.022.984 0 1.817.34 2.498 1.022.682.682 1.023 1.515 1.023 2.499a3.301 3.301 0 01-.705 2.058l3.047 3.047c.1.1.15.221.15.366a.52.52 0 01-.163.379c-.1.1-.226.149-.38.149a.514.514 0 01-.378-.15zm-5.092-3.412c.677 0 1.252-.237 1.727-.71.473-.475.71-1.05.71-1.727s-.237-1.253-.71-1.727a2.352 2.352 0 00-1.727-.71c-.677 0-1.253.236-1.727.71a2.352 2.352 0 00-.71 1.727c0 .677.236 1.252.71 1.727.474.473 1.05.71 1.727.71z","fill":"currentColor"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5307_8304"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    